import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 配置Axios
// 生产环境，直接连接后端API
// 使用相对路径，自动适应当前页面的协议
axios.defaults.baseURL = '/api'
axios.defaults.timeout = 10000

// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 从localStorage获取token
  const token = localStorage.getItem('token')
  // 只有当token存在且不是'undefined'字符串时才添加到请求头
  if (token && token !== 'undefined' && token !== 'null') {
    config.headers.Authorization = `Bearer ${token}`
  }
  // 调试输出请求URL
  console.log('Request URL:', config.baseURL + config.url)
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response.data
}, error => {
  return Promise.reject(error)
})

Vue.prototype.$axios = axios

Vue.use(ElementUI, {
  // 全局配置消息提示的默认时长
  message: {
    duration: 2000
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')